// extracted by mini-css-extract-plugin
export default {"ticker":"ticker_ticker__zu1lu"};